/* eslint-disable */
import _ from 'lodash';

const getters = {
  isShopAuthenticated: state => state.authenticated,
  shopToken: state => state.shopToken,
  currentShop: state => state.shop,
  currentShopId: state => _.get(state, 'shop.shopId', null),
};

export default getters;
